export enum MetadataTypesEnum {
  DriveMetadata = 'DriveMetadata',
  DropboxMetaEntryModel = 'DropboxMetaEntryModel',
  DropboxMetaModel = 'DropboxMetaModel',
  OneDriveMetadata = 'OneDriveMetadata',
}
